import { formatDistanceStrict } from "date-fns";
import { useEffect, useState } from "react";
import { date } from "@/lib/utils";

export function RelativeTime({ value, label }: { value: string | Date; label?: string }) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(timer);
  }, []);
  return (
    <time
      dateTime={new Date(value).toISOString()}
      title={`${label ? `${label} ` : ""}${date(value, true)}`}
      suppressHydrationWarning
    >
      {formatDistanceStrict(new Date(value), now, { addSuffix: true })}
    </time>
  );
}
